import { featureCards } from '@/mocks/homeData';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: {
    bg: 'hover:bg-primary-50 border-primary-100',
    text: 'text-primary-600',
    iconBg: 'bg-primary-100',
  },
  accent: {
    bg: 'hover:bg-accent-50 border-accent-100',
    text: 'text-accent-600',
    iconBg: 'bg-accent-100',
  },
};

export default function FeatureCards() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Everything About Basetao In One Place
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            Your complete resource hub covering every aspect of the Basetao shopping experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featureCards.map((card) => {
            const colors = colorMap[card.color] || colorMap.primary;
            return (
              <div
                key={card.title}
                className={`group p-5 md:p-6 bg-background-50 border border-background-200 rounded-lg transition-all duration-200 cursor-pointer ${colors.bg}`}
              >
                <div className={`w-11 h-11 flex items-center justify-center rounded-lg ${colors.iconBg} mb-4`}>
                  <i className={`${card.icon} text-xl ${colors.text}`}></i>
                </div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {card.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}